const _temp0 = require("../../../img/browsers/baidu.svg");
const _temp1 = require("../../../img/browsers/blackberry.svg");
const _temp2 = require("../../../img/browsers/chrome.svg");
const _temp3 = require("../../../img/browsers/edge.svg");
const _temp4 = require("../../../img/browsers/firefox.svg");
const _temp5 = require("../../../img/browsers/ie.svg");
const _temp6 = require("../../../img/browsers/kai.svg");
const _temp7 = require("../../../img/browsers/opera.svg");
const _temp8 = require("../../../img/browsers/qq.svg");
const _temp9 = require("../../../img/browsers/safari.svg");
const _temp10 = require("../../../img/browsers/samsung.svg");
const _temp11 = require("../../../img/browsers/uc.svg");
module.exports = {
  "baidu": _temp0,
  "blackberry": _temp1,
  "chrome": _temp2,
  "edge": _temp3,
  "firefox": _temp4,
  "ie": _temp5,
  "kai": _temp6,
  "opera": _temp7,
  "qq": _temp8,
  "safari": _temp9,
  "samsung": _temp10,
  "uc": _temp11
}